export default {
    home: 'Home',
    companies: 'Companies',
    threats: 'Threats',
    assets: 'Assets',
    users: 'Users',
    roles: 'Roles',
    myAccount: 'My account',
    risksModule: 'Risk Management',
    pentestingModule: 'Ciberdiagnóstico',
};
